import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'currency-monero', 'CurrencyMonero', [["path",{"d":"M3 18h3v-11l6 7l6 -7v11h3","key":"svg-0"}]]);